import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function HistorySidebar({ articles, activeSlug }) {
  // const { t } = useTranslation();

  const categories = [...new Set(articles.map((article) => article.category))];

  const [openCategories, setOpenCategories] = useState(
    Object.fromEntries(categories.map((category) => [category, true])),
  );

  const toggleCategory = (category) => {
    setOpenCategories((current) => ({
      ...current,
      [category]: !current[category],
    }));
  };

  return (
    <aside className="article-sidebar">
      <div className="flex h-full flex-col">
        {/* <div className="border-b border-gray-200 p-5">
          <h2 className="base-title">{t("articles.title")}</h2>
        </div> */}

        <nav className="flex-1 overflow-y-auto p-4">
          {categories.map((category) => {
            const categoryArticles = articles.filter(
              (article) => article.category === category,
            );

            const isCategoryOpen = openCategories[category];

            return (
              <div key={category} className="mb-4">
                <button
                  type="button"
                  onClick={() => toggleCategory(category)}
                  className="flex w-full items-center justify-between text-left"
                  aria-expanded={isCategoryOpen}
                >
                  <span className="base-subtitle">{category}</span>

                  <i
                    className={`fas fa-chevron-${
                      isCategoryOpen ? "down" : "right"
                    } text-xs`}
                    aria-hidden="true"
                  />
                </button>

                {isCategoryOpen && (
                  <div>
                    {categoryArticles.map((article) => (
                      <Link
                        key={article.slug}
                        to={`/pillole-di-storia/${article.slug}`}
                        className={`
                          article-link
                          ${
                            article.slug === activeSlug
                              ? "article-active"
                              : "article-title"
                          }
                        `}
                      >
                        {article.title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}

export default HistorySidebar;
